import { DSMobileLoadingPage } from './Page.js';

export { DSMobileLoadingPage };
